import React, { useEffect, useState } from "react";
import FiltersTrackCase, {
  FiltersSelectType,
  SearchFormDataType,
  SearchPayloadType,
} from "./FiltersTrackCase";
import { ColumnsType } from "antd/es/table";
import { cellWidth } from "../../core/methods/tableCellWidth";
import Datatable from "../../core/common/dataTable";
import TimelineModal from "./TimelineModal";
import { parseNumber, parseTiming } from "../../core/methods/sorterMethods";
import {
  dummyData_stoppedCases,
  timelineData_invite,
} from "../../core/data/js/dummy-data";
import Footer from "../../core/common/Footer";
import { getSearchableHeader } from "../utils/getSearchableHeader";
import { statusColors } from "./ApplicantInvited";
import Swal from "sweetalert2";
import useApi from "../../core/customhook/useApi";
import webservice_url from "../../core/webservice/Webservice_url";
import CaseActionModal from "./work-in-progress/CaseActionModal";
import SnipperLoader from "../../core/common/loader/SnipperLoader";
import { exportAntdTableToExcel } from "../utils/exportExcel";

export type TableApiPayload = {
  program_id: string[];
  department_id: string[];
  status: string[];
  project_id: string[];
  assigned_user_id: string[];
  page: number;
  limit: number;
};
const buildTableApiPayload = (
  searchPayload: Partial<SearchPayloadType>,
  page: number,
  limit: number,
  statusId?: string,
): TableApiPayload => ({
  program_id: searchPayload.program ?? [],
  department_id: searchPayload.department ?? [],
  status: statusId ? [statusId] : [],
  project_id: searchPayload.project ?? [],
  assigned_user_id: searchPayload.users ?? [],
  page,
  limit,
});
const StoppedCases = () => {
  const [itemList, setItemList] = useState<any[]>([]);

  const [searchFilter, setSearchFilter] = useState<SearchFormDataType>({
    case_id: "",
    applicant_name: "",
    email: "",
    from_date: "",
    to_date: "",
  });
  const [filterData, setFilterData] = useState<FiltersSelectType>({
    organization: [],
    project: [],
    location: [],
    program: [],
    users: [],
  });

  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});
  const [total, setTotal] = useState(0);

  const [pagination, setPagination] = useState({ page: 1, limit: 10 });

  const getTableData = useApi<any>(webservice_url.StopCaseTableAPI, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const fetchTableData = async (
    searchPayload: Partial<SearchPayloadType>,
    page: number,
    limit: number,
  ) => {
    try {
      const apiPayload = buildTableApiPayload(searchPayload, page, limit);
      const res = await getTableData.callApi(apiPayload);
      setItemList(res?.data?.table);
      const paginationInfo = res?.data?.pagination;
      setPagination({
        page: paginationInfo?.page ?? page,
        limit: paginationInfo?.limit ?? limit,
      });
    } catch (err) {
      console.error(err);
      setItemList([]);
    }
  };
  useEffect(() => {
    // if (!buildTableApiPayload) {
    fetchTableData({}, pagination.page, pagination.limit);
    // }
  }, []);
  type InviteItem = any;
  const filteredData = (Array.isArray(itemList) ? itemList : []).filter(
    (item: InviteItem) => {
      return Object.entries(inventoryColumnSearch).every(([key, value]) => {
        if (!value) return true;

        return String(item[key as keyof InviteItem] ?? "")
          .toLowerCase()
          .includes(value.toLowerCase());
      });
    },
  );

  const [resumeRecord, setResumeRecord] = useState<any>(null);
  const [resumeLoading, setResumeLoading] = useState(false);

  const handleResumeClick = (record: any) => {
    setResumeRecord(record);
  };

  const getCaseStatuses = useApi<any>(webservice_url.GetCaseStatus, {
    method: "GET",
    autoCall: true,
    handleGlobalError: false,
  });

  const caseStatusUpdateAPI = useApi<any>(webservice_url.updateCaseStatus, {
    method: "PATCH",
    autoCall: false,
    handleGlobalError: false,
  });

  const getStatusIdByName = (statusName: string): string | undefined => {
    const statusList = getCaseStatuses?.data?.data ?? [];
    return statusList.find((s: any) => s.status_name === statusName)?.status_id;
  };

  // VIEW LOG API CALLING
  const [timelineData, setTimelineData] = useState<any[]>([]);
  const [timelineLoading, setTimelineLoading] = useState<boolean>(false);
  const [lastSearchPayload, setLastSearchPayload] = useState<
    Partial<SearchPayloadType>
  >({});
  const getCaseLog = useApi<any>(webservice_url.ViewLogAPI, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const handleSearch = (payload: SearchPayloadType) => {
    setLastSearchPayload(payload);
    setPagination({ page: 1, limit: pagination.limit });
    fetchTableData(payload, 1, pagination.limit);
  };
  const handleViewLog = async (caseId?: string) => {
    if (!caseId) return;
    setShowTimeline(true);
    setTimelineLoading(true);
    try {
      const res = await getCaseLog.callApi({ case_id: caseId });
      setTimelineData(res?.data ?? []);
    } catch (err) {
      console.error(err);
      setTimelineData([]);
    } finally {
      setTimelineLoading(false);
    }
  };

  const token = localStorage.getItem("userId");

  // const handleConfirmResume = async (reason: string) => {
  //   if (!resumeRecord) return;
  //   try {
  //     setResumeLoading(true);
  //     const statusId = getStatusIdByName("RESUME");

  //     if (!statusId) {
  //       Swal.fire({
  //         title: "Error",
  //         text: `Status "RESUME" not found. Please refresh and try again.`,
  //         icon: "error",
  //       });
  //       return;
  //     }
  //     await caseStatusUpdateAPI.callApi({
  //       case_id: resumeRecord.case_id,
  //       status: statusId,
  //       actor_id: token,
  //       actor_type: "admin",
  //       action_reason: reason,
  //     });

  //     setItemList((prev) =>
  //       prev.map((item) =>
  //         item.caseId === resumeRecord.caseId
  //           ? { ...item, status: "WORK IN PROGRESS" }
  //           : item,
  //       ),
  //     );
  //     setResumeRecord(null);
  //     await Swal.fire({
  //       title: "Resumed!",
  //       text: "The case has been resumed.",
  //       icon: "success",
  //       timer: 1500,
  //       showConfirmButton: true,
  //     });
  //   } catch (error) {
  //     console.error("Resume failed:", error);
  //     Swal.fire({
  //       title: "Error",
  //       text: "Something went wrong. Please try again.",
  //       icon: "error",
  //     });
  //   } finally {
  //     setResumeLoading(false);
  //   }
  // };
  const handleConfirmResume = async (reason: string) => {
    if (!resumeRecord) return;
    try {
      setResumeLoading(true);
      const statusId = getStatusIdByName("RESUME");

      if (!statusId) {
        Swal.fire({
          title: "Error",
          text: `Status "RESUME" not found. Please refresh and try again.`,
          icon: "error",
        });
        return;
      }

      const res = await caseStatusUpdateAPI.callApi({
        case_id: resumeRecord.case_id,
        status: statusId,
        actor_id: token,
        actor_type: "admin",
        action_reason: reason,
      });

      if (res?.success === false) {
        Swal.fire({
          title: "Error",
          text: res?.message || "Unable to resume case.",
          icon: "error",
        });
        return;
      }

      setResumeRecord(null);

      // Recall the table with the same filters and page
      await fetchTableData(
        lastSearchPayload,
        pagination.page,
        pagination.limit,
      );

      await Swal.fire({
        title: "Resumed!",
        text: "The case has been resumed.",
        icon: "success",
        timer: 1500,
        showConfirmButton: true,
      });
    } catch (error) {
      console.error("Resume failed:", error);
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    } finally {
      setResumeLoading(false);
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      width: 80,
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Applicant Name",
        "candidate_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "candidate_name",
      key: "candidate_name",
      onCell: () => cellWidth(200),
      sorter: (a: any, b: any) =>
        a.candidate_name.localeCompare(b.candidate_name),
    },
    {
      title: getSearchableHeader(
        "Case ID",
        "case_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_id",
      key: "case_id",
      onCell: () => cellWidth(120),
      sorter: (a: any, b: any) =>
        parseNumber(a.case_id) - parseNumber(b.case_id),
    },
    {
      title: getSearchableHeader(
        "Case Status",
        "overall_status",
        setInventoryColumnSearch,
      ),
      dataIndex: "overall_status",
      key: "overall_status",
      onCell: () => cellWidth(140),
      sorter: (a: any, b: any) =>
        (a.overall_status ?? "").localeCompare(b.overall_status ?? ""),
      render: (text: any, record: any) => {
        return (
          <span
            style={{
              backgroundColor: record?.overall_color_value || "#6c757d",
              color: "#fff",
              padding: "5px 10px",
              borderRadius: "4px",
              display: "inline-block",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {text ?? "-"}
          </span>
        );
      },
    },
    {
      title: getSearchableHeader(
        "Project",
        "project_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "project_name",
      key: "project_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.project_name ?? "").localeCompare(b.project_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Program",
        "program_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "program_name",
      key: "program_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.program_name ?? "").localeCompare(b.program_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Department",
        "department_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "department_name",
      key: "department_name",
      onCell: () => cellWidth(220),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.department_name ?? "").localeCompare(b.department_name ?? ""),
    },
    {
      title: getSearchableHeader("Email ID", "email", setInventoryColumnSearch),
      dataIndex: "email",
      key: "email",
      sorter: (a: any, b: any) => a.email.localeCompare(b.email),
    },
    {
      title: getSearchableHeader(
        "Total checks",
        "total_checks",
        setInventoryColumnSearch,
      ),
      dataIndex: "total_checks",
      key: "total_checks",
      onCell: () => cellWidth(180),
      sorter: (a, b) => a.total_checks - b.total_checks,
    },

    {
      title: getSearchableHeader(
        "Stopped checks",
        "stopped_checks",
        setInventoryColumnSearch,
      ),
      dataIndex: "stopped_checks",
      key: "stopped_checks",
      onCell: () => cellWidth(180),
      sorter: (a, b) => a.stopped_checks - b.stopped_checks,
    },
    // {
    //   title: getSearchableHeader("Status", "status", setInventoryColumnSearch),
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   onCell: () => cellWidth(150),
    //   render: (status: string) => {
    //     return (
    //       <span className={`badge ${statusColors[status] || "bg-secondary"}`}>
    //         {status}
    //       </span>
    //     );
    //   },
    //   sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    // },
    {
      title: getSearchableHeader(
        "Processing Time",
        "processing_time_hours",
        setInventoryColumnSearch,
      ),
      dataIndex: "processing_time_hours",
      key: "processing_time_hours",
      onCell: () => cellWidth(200),
      render: (value: number | string) =>
        value != null ? Number(value).toFixed(2) : "-",
      sorter: (a, b) =>
        parseTiming(a.processing_time_hours) -
        parseTiming(b.processing_time_hours),
    },
    {
      title: "Action",
      key: "row_action",
      width: 140,
      render: (_: any, record: any) =>
        record.case_status === "STOP" ? (
          <button
            type="button"
            className="btn btn-success btn-sm"
            onClick={() => handleResumeClick(record)}
          >
            Resume
          </button>
        ) : (
          <span className="badge bg-secondary">Resumed</span>
        ),
    },
    {
      title: "View Log",
      key: "viewLog",
      onCell: () => cellWidth(120),
      render: (_: any, record: any) => (
        <div
          className="text-center text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => handleViewLog(record.case_id)}
        >
          <i className="ti ti-eye "></i>
        </div>
      ),
    },
  ];

  const handleTableChange = (
    page: number,
    limit: number = pagination.limit,
  ) => {
    if (page === pagination.page && limit === pagination.limit) {
      return;
    }
    setPagination({ page, limit });
    fetchTableData(lastSearchPayload, page, limit);
  };
  const loading = getTableData.loading;

  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns,
      dataSource: filteredData,
      fileName: "Stopped_Cases_Report",
      sheetName: "Stopped Cases",
    });
  };

  const CaseMark = () => (
    <svg
      className="tcp-case-mark"
      viewBox="0 0 40 32"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0" y="14" width="4" height="18" rx="1.5" />
      <rect x="9" y="8" width="4" height="24" rx="1.5" />
      <rect x="18" y="0" width="4" height="32" rx="1.5" />
      <rect x="27" y="10" width="4" height="22" rx="1.5" />
      <rect x="36" y="18" width="4" height="14" rx="1.5" />
    </svg>
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="tcp-header-title-row mb-3">
          <CaseMark />
          <div>
            <h4 className="tcp-title">Stopped Cases</h4>
            <p className="tcp-subtitle">
              Review stopped cases, identify the reasons for stoppage, and take
              necessary action where applicable.
            </p>
          </div>
        </div>
        <>
          <FiltersTrackCase
            filterData={filterData}
            searchFilter={searchFilter}
            setFilterData={setFilterData}
            setSearchFilter={setSearchFilter}
            storageKey="stopped_cases"
            onSearch={handleSearch}
          />

          {loading ? (
            <SnipperLoader />
          ) : (
            <div className="card mt-3 pt-2 pe-0">
              <div className="text-end px-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={handleDownloadExcel}
                  disabled={loading}
                >
                  <i className="bi bi-download pe-2"></i>
                  Export to Excel
                </button>
              </div>
              <Datatable
                dataSource={filteredData}
                columns={columns}
                Selection={false}
                fixedHeader
                tableHeight={650}
                pagination={{
                  current: pagination.page,
                  pageSize: pagination.limit,
                  total,
                }}
                handleTableChange={(pagination: any) => {
                  handleTableChange(pagination.current, pagination.pageSize);
                }}
              />
            </div>
          )}

          {/* Timeline modal */}
          {showTimeline && (
            <TimelineModal
              timelineData={timelineData}
              loading={timelineLoading}
              onClose={() => {
                setShowTimeline(false);
                setTimelineData([]);
              }}
            />
          )}
          {resumeRecord && (
            <CaseActionModal
              isOpen={!!resumeRecord}
              title="Resume Case"
              confirmLabel="Resume Case"
              confirmButtonClass="btn-secondary"
              reasonLabel="Enter reason of resuming case"
              onClose={() => setResumeRecord(null)}
              onConfirm={handleConfirmResume}
              baseFields={[
                { label: "Candidate Name", value: resumeRecord.candidate_name },
                { label: "Case ID", value: resumeRecord.case_id },
                { label: "Email", value: resumeRecord.email },
              ]}
              extraFields={[
                { label: "Stop Reason", value: resumeRecord.action },
              ]}
              loading={resumeLoading}
            />
          )}
        </>
      </div>

      <Footer />
    </div>
  );
};

export default StoppedCases;
